import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { empty_stars_all, empty_stars_enrolled } from "../pngs";
import {
  tokenSolver,
  getFromStorage,
  stars,
  scrollToTop,
  privGtmKey,
} from "../utils";
import {
  CoalitionSpinner,
  EmptyBlockVertical,
  CoalitionCardStars,
  NavButton,
  isTokenValid,
} from "../components";
import {
  sendTag,
  event_properties_106_01,
  event_properties_106_02,
  event_properties_106_03,
} from "../components/CoalitionGtm";
import "./../App.scss";

export const StarsPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [starsCards, updateStarsCards] = useState([]);

  useEffect(() => {
    if (!isTokenValid()) return navigate("/unauth");
    const setStarsCards = async () => {
      setLoading(true);
      const rawStars = getFromStorage(stars);
      await updateStarsCards(rawStars);
      setLoading(false);
      scrollToTop();
    };
    setStarsCards();
  }, []);

  const [page, setPage] = useState(0);

  const setKlass = (idx) => `opt${page === idx ? " active" : ""}`;

  const gtm = localStorage.getItem(privGtmKey);
  const title = "Vive experiencias";
  const layers = [
    {
      label: "Todas",
      emptyStateImg: empty_stars_all,
      emptyStateText:
        "Muy pronto podrás juntar estrellas para vivir experiencias únicas al participar",
      set: starsCards ?? [],
      event: event_properties_106_01(),
    },
    {
      label: "Ya participas",
      emptyStateImg: empty_stars_enrolled,
      emptyStateText:
        "Comienza a participar en las dinámicas para ganar y vivir experiencias únicas",
      set: starsCards
        ? starsCards.filter((promo) => promo.points !== undefined)
        : [],
      event: event_properties_106_02(),
    },
  ];

  useEffect(() => {
    if (gtm) sendTag(gtm, layers[page].event);
  }, [page]);

  return (
    <>
      <div className="stars-page">
        {loading ? (
          <CoalitionSpinner />
        ) : (
          <>
            <div className="nav">
              <NavButton
                title={title}
                buttonClicked={() => navigate(`/?${tokenSolver()}`)}
              />
              <div className="options-menu">
                {layers.map((layer, idx) => (
                  <div
                    key={idx}
                    onClick={() => setPage(idx)}
                    onKeyPress={() => setPage(idx)}
                    role="button"
                    tabIndex={0}
                    className={setKlass(idx)}
                    style={{ width: `${100 / layers.length}%` }}
                  >
                    <div>{layer.label}</div>
                    {page === idx ? (
                      <div
                        className="indicator"
                        style={{
                          width: `${100 / layers.length}%`,
                          left: `${(100 / layers.length) * idx}%`,
                        }}
                      />
                    ) : null}
                  </div>
                ))}
              </div>
            </div>
            <div className="content">
              {!layers[page].set || layers[page].set.length === 0 ? (
                <div className="empty-state">
                  <EmptyBlockVertical
                    description={layers[page].emptyStateText}
                    emptyState={layers[page].emptyStateImg}
                  />
                </div>
              ) : (
                <>
                  <div className="carousel-cards">
                    {layers[page].set.map((i, k) => (
                      <CoalitionCardStars
                        key={k}
                        card={i}
                        promoClicked={() => {
                          if (gtm) {
                            let payload = event_properties_106_03();
                            payload.experience_id = i.offer_id;
                            payload.experience_progress = `${
                              i.points ?? 0
                            } estrellas`;
                            sendTag(gtm, payload);
                          }
                          const state = { state: { origin: "page" } };
                          const path = `/stars/${i.offer_id}?${tokenSolver()}`;
                          navigate(path, state);
                        }}
                      />
                    ))}
                  </div>
                </>
              )}
            </div>
          </>
        )}
      </div>
    </>
  );
};
